import { isLocalhost } from 'app-logic/http/helpers/isLocalHost'
import { Log } from '@xylabs/log'

export const log = new Log({
  commitHash: process.env.REACT_APP_VERSION,
  devMode: isLocalhost(),
  rollbarToken: 'd4766b39c1cf47f49e8ea69d6b41d49f',
})